import { SESSION_KEY_PREFIX } from "../../session/sessionManager";

export const PRE_UMP_SESSION_KEY_PREFIX = "Kismet_events_";

export function storeEventInSessionStorage(
  eventName: string,
  eventData: any,
  clientId: string
): void {
  try {
    console.debug("[storeEventInSessionStorage]");
    if (!clientId) return;

    // Get the session for this client
    const sessionKey = `${SESSION_KEY_PREFIX}${clientId}`;
    const sessionData = sessionStorage.getItem(sessionKey);

    if (!sessionData) {
      console.debug(
        `No session found for client ${clientId}, cannot store event`
      );
      return;
    }

    // Parse the session to get the pre-UMP ID
    const session = JSON.parse(sessionData);

    if (!session.pre_UMP_ID) {
      console.error(`No pre-UMP ID found in session for client ${clientId}`);
      return;
    }

    // Create storage key using the pre-UMP ID
    const storageKey = `${PRE_UMP_SESSION_KEY_PREFIX}${clientId}_${
      session.UMP_ID ? `ump_${session.UMP_ID}` : `tmp_${session.pre_UMP_ID}`
    }`;

    console.debug(
      `📋 [Session Storage] Storing event "${eventName}" for client: ${clientId}`
    );
    console.debug(`📋 [Session Storage] Using key: ${storageKey}`);

    // Retrieve existing data or initialize new storage object
    let storedData;
    let existingData = null;
    try {
      existingData = sessionStorage.getItem(storageKey);
      if (existingData) {
        console.debug(
          `📋 [Session Storage] Found existing data for ${storageKey}`
        );
        storedData = JSON.parse(existingData);
      } else {
        console.debug(
          `📋 [Session Storage] Creating new entry for ${storageKey}`
        );
        storedData = {
          id_type: "PRE_UMP_ID",
          metrics: {},
          status: "pending_identification",
          preUmpId: session.pre_UPM_ID,
          clientId: clientId,
        };
      }
    } catch (error) {
      console.error("Failed to parse existing event data:", error);
      storedData = {
        id_type: "PRE_UMP_ID",
        metrics: {},
        status: "pending_identification",
        preUmpId: session.pre_UPM_ID,
        clientId: clientId,
      };
    }

    // Check if there's a metricName in the eventData
    if (eventData.metricName) {
      const metricName = eventData.metricName;
      const metricValue = eventData.value !== undefined ? eventData.value : 1;

      console.debug(
        `📋 [Session Storage] Found metricName: ${metricName}, value: ${metricValue}`
      );

      // Hard rule: date fields must ALWAYS be ISO strings
      if (
        metricName === "viewedAt" ||
        metricName === "clickedAt" ||
        metricName === "convertedAt"
      ) {
        // No flexibility - always use current time in ISO format
        storedData.metrics[metricName] = new Date().toISOString();
      } else {
        // Non-date fields
        storedData.metrics[metricName] = metricValue;
      }
    } else {
      // Update metrics based on event type directly - legacy approach
      console.debug(
        `📋 [Session Storage] Using event name directly: ${eventName}`
      );
      storedData.metrics[eventName] = (storedData.metrics[eventName] || 0) + 1;
    }

    // Store timestamp
    storedData.metrics.timestamp = new Date().toISOString();

    // Log the update
    console.debug(`📋 [Session Storage] Updated metrics:`, storedData.metrics);

    // Save back to session storage
    sessionStorage.setItem(storageKey, JSON.stringify(storedData));

    // Final confirmation
    console.debug(
      `📋 [Session Storage] Successfully stored event data for ${eventName}`
    );
  } catch (error) {
    console.error(`Error storing event "${eventName}":`, error);
  }
}
